

export function IEVersion() {

	let ua = window.navigator.userAgent
	let msie = ua.indexOf('MSIE ')
	let trident = ua.indexOf('Trident/')
	let edge = ua.indexOf('Edge/')

	// IE 10 or older => return version
	if (msie > 0) return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)

	// IE 11 => return version
	if (trident > 0) {
		var rv = ua.indexOf('rv:')
		return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
	}

	// Edge (IE 12+) => return version
	if (edge > 0) return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)

	return null
}


export const isIE = () => (IEVersion() !== null)


export const addHTMLClass = () => {
	const version = IEVersion()
	version && document.documentElement.classList.add(`ie${version}`)
}